<template>
    <div class="cont-tit">
        <div class="cont-inner">
            <h2 class="page-title">O2O Service Introduction</h2>
            <p class="page-desc">The OSE-B2C/B2B/O2O Commerce Ver.1.2 platform provides optimized functions for various fields such as B2C, B2B, and O2O service industries. <br>
                It is a flexible and scalable CLOUD Compute-based solution that promotes digital transformation <br>
                by supporting customized shopping experiences and efficient merchant and supply chain management.</p>
        </div>
    </div>
    <div class="introduction">
        <section class="introduction-sec1">
            <div class="introduction--sec1__inner">
                <img src="../../assets/resource/img/introduction-img001.png" alt="">
                <div class="introduction-sec1__box">
                    <div class="introduction-sec1__text">
                        <h3>B2C/B2B/O2O Mall Service</h3>
                        <p>From product sales to offline services
                            Beyond simple product sales, you can also reserve services that require
                            communication with customers. custom sales site</p>
                    </div>
                    <div class="introduction-sec1__text">
                        <h3>O2O affiliate management system (store/supplier)</h3>
                        <ul>
                            <li>Customized management services on and off line</li>
                            <li>From basic information management to product management to settlement management, order management services from 1:1 inquiries</li>
                        </ul>
                    </div>
                    <div class="introduction-sec1__text">
                        <h3>O2O integrated manager system</h3>
                        <p>Supports various functions from easy affiliate monitoring to marketing
                            management</p>
                    </div>
                </div>
            </div>
            <div class="text-box">
                <p class="text-box__desc">Laying the foundation for new service introduction by expanding online and offline service channels <br>
                    Expanding O2O service channels such as mobile web, hybrid app, tablet, and IOT</p>
            </div>
        </section>
        <section class="introduction-sec2">
            <div class="introduction-sec2__inner">
                <h3 class="c-red">Key Features</h3>
                <ul class="introduction-sec2__list">
                    <li class="introduction-sec2__item">
                        <div class="top">
                            <div class="num">01</div>
                            <h5 class="tit">Cloud-based architecture</h5>
                            <p class="desc">AWS and other cloud services ensure platform scalability and flexibility and support global expansion.</p>
                        </div>
                        <div class="bottom">
                            <p>Reduced infrastructure costs, easy service expansion, easy entry into global markets</p>
                        </div>
                    </li>
                </ul>
            </div>

            <div class="introduction-sec2__inner">
                <h3>OSE-B2C/B2B/O2O Mall Service</h3>
                <ul class="introduction-sec2__list">
                    <li class="introduction-sec2__item">
                        <div class="top">
                            <div class="num">02</div>
                            <h5 class="tit">Integrated operation management</h5>
                            <p class="desc">Provide a consistent customer experience by managing product information, orders, and inventory status across all sales channels without boundaries between online and offline.</p>
                        </div>
                        <div class="bottom">
                            <p>Increased customer retention rate <br>
                                Improve operational efficiency Deliver consistent brand experiences</p>
                        </div>
                    </li>
                    <li class="introduction-sec2__item">
                        <div class="top">
                            <div class="num">03</div>
                            <h5 class="tit">Custom product recommendations</h5>
                            <p class="desc">Analyzing customer purchase patterns and providing personalized product recommendations through data analysis, increasing customer participation and conversion rate</p>
                        </div>
                        <div class="bottom">
                            <p>Increased customer satisfaction <br>
                                increase in sales <br>
                                Reduce customer churn rate</p>
                        </div>
                    </li>
                    <li class="introduction-sec2__item">
                        <div class="top">
                            <div class="num">04</div>
                            <h5 class="tit">Real-time notifications <br>
                                and location-based services</h5>
                            <p class="desc">Using LBS and LCS technology <br>
                                Order and service status updates and location-based services
                                offer</p>
                        </div>
                        <div class="bottom">
                            <p>Improved customer convenience <br>
                                Strengthening real-time response capabilities <br>
                                Improving customer experience</p>
                        </div>
                    </li>
                </ul>
            </div>

            <div class="introduction-sec2__inner">
                <h3>OSE_O2O Affiliate Management System</h3>
                <ul class="introduction-sec2__list">
                    <li class="introduction-sec2__item">
                        <div class="top">
                            <div class="num">05</div>
                            <h5 class="tit">Integrated operation management</h5>
                            <p class="desc">Transactions between stores and suppliers are centralized management, automated inventory and order processing. Save time and money</p>
                        </div>
                        <div class="bottom">
                            <p>Increase operational efficiency <br>
                                Save time and money <br>
                                Management Optimization</p>
                        </div>
                    </li>
                    <li class="introduction-sec2__item">
                        <div class="top">
                            <div class="num">06</div>
                            <h5 class="tit">Contract and transaction automation</h5>
                            <p class="desc">Contracts, orders between stores and suppliers,
                                Streamline the transaction process with automatic management of shipping information</p>
                        </div>
                        <div class="bottom">
                            <p>Reduce human error <br>
                                Increased transaction speed and accuracy <br>
                                Simplify your work</p>
                        </div>
                    </li>
                    <li class="introduction-sec2__item">
                        <div class="top">
                            <div class="num">07</div>
                            <h5 class="tit">Product and inventory management</h5>
                            <p class="desc">Manage product registration, price settings,
                                and inventory status in real time</p>
                        </div>
                        <div class="bottom">
                            <p>Solve stock shortage or overstock issues <br>
                                Improved product management efficiency <br>
                                Sales Optimization</p>
                        </div>
                    </li>
                </ul>
            </div>

            <div class="introduction-sec2__inner">
                <h3>OSE_O2O integrated management system</h3>
                <ul class="introduction-sec2__list">
                    <li class="introduction-sec2__item">
                        <div class="top">
                            <div class="num">08</div>
                            <h5 class="tit">Multi-user management</h5>
                            <p class="desc">Administrator has multiple user rights <br>
                                Set up and monitor activity</p>
                        </div>
                        <div class="bottom">
                            <p>Increased transparency and security of user activity Increased user management efficiency</p>
                        </div>
                    </li>
                    <li class="introduction-sec2__item">
                        <div class="top">
                            <div class="num">09</div>
                            <h5 class="tit">Integrated data analysis</h5>
                            <p class="desc">Support strategic decision-making by collecting and analyzing data across platforms</p>
                        </div>
                        <div class="bottom">
                            <p>Strengthening data-based decision making <br>
                                Derive business insights <br>
                                Establish a customized marketing strategy</p>
                        </div>
                    </li>
                    <li class="introduction-sec2__item">
                        <div class="top">
                            <div class="num">10</div>
                            <h5 class="tit">advanced security protocols</h5>
                            <p class="desc">Applying the latest security technology, <br>
                                TLS/SSL encryption, <br>
                                User authentication through OAuth 2.0, <br>
                                Session management using JWT, <br>
                                ISMS authentication <br>
                                Ensure data protection and system stability</p>
                        </div>
                        <div class="bottom">
                            <p>Reduce security threats <br>
                                Maintain data integrity and confidentiality <br>
                                regulatory compliance</p>
                        </div>
                    </li>
                </ul>
            </div>
        </section>

        <section class="introduction-sec3">
            <div class="introduction-sec3__text">
                <h3>Main Consumer Base</h3>
                <p>The OSE-B2C/B2B/O2O Commerce platform provides core digital transformation solutions in various industries <br>
                    such as mobility, golf, pets, distribution, and food e-commerce. Strengthening O2O multi-channel management, customized services, <br>
                    and information security (ISMS) through successful projects with Hyundai/Kia Motors and small and medium-sized businesses. <br>
                    We have realized operational efficiency optimized for each industry.</p>
            </div>
            <ul class="introduction-sec3__list">
                <li class="introduction-sec3__item">
                    <img src="../../assets/resource/icon/introduction-icon01.svg" alt="">
                    <h4>Mobility Industry</h4>
                    <ul>
                        <li>
                            <h5>Vehicle maintenance service booking</h5>
                            <p>Online booking, location tracking and service management</p>
                        </li>
                        <li>
                            <h5>Route optimization and fleet management</h5>
                            <p>GPS and IoT-based route optimization, vehicle maintenance automation</p>
                        </li>
                        <li>
                            <h5>Real-time pickup and parking management</h5>
                            <p>Based on location and movement data</p>
                        </li>
                    </ul>
                </li>
                <li class="introduction-sec3__item">
                    <img src="../../assets/resource/icon/introduction-icon02.svg" alt="">
                    <h4>Golf Industry</h4>
                    <ul>
                        <li>
                            <h5>Sell golf equipment online</h5>
                            <p>Sales and management of golf clubs, etc.</p>
                        </li>
                        <li>
                            <h5>Golf tee time reservation system</h5>
                            <p>Golf course tee time scheduling and management</p>
                        </li>
                        <li>
                            <h5>Customized recommendation service</h5>
                            <p>Recommend equipment through analysis of play style and preference</p>
                        </li>
                    </ul>
                </li>

                <li class="introduction-sec3__item">
                    <img src="../../assets/resource/icon/introduction-icon03.svg" alt="">
                    <h4>Pet Industry</h4>
                    <ul>
                        <li>
                            <h5>Online pet shop and booking services</h5>
                            <p>Sales of various pet-related products and reservations for hospital and grooming services</p>
                        </li>
                        <li>
                            <h5>Personalized pet care solutions</h5>
                            <p>Pet information</p>
                        </li>
                        <li>
                            <h5>Based diet and product recommendations</h5>
                        </li>
                        <li>
                            <h5>pet care and customer interaction</h5>
                            <p>Health record management</p>
                        </li>
                    </ul>
                </li>

                <li class="introduction-sec3__item">
                    <img src="../../assets/resource/icon/introduction-icon04.svg" alt="">
                    <h4>Merchandise/Retail Industry</h4>
                    <ul>
                        <li>
                            <h5>Multi-channel retailing and e-commerce platform</h5>
                            <p>Commerce through mobile and hybrid apps</p>
                        </li>
                        <li>
                            <h5>automate inventory and fulfillment</h5>
                            <p>Increased operational efficiency through automation of the entire purchasing process</p>
                        </li>
                    </ul>
                </li>

                <li class="introduction-sec3__item">
                    <img src="../../assets/resource/icon/introduction-icon05.svg" alt="">
                    <h4>Food & Beverage Industry</h4>
                    <ul>
                        <li>
                            <h5>Online ordering and payment systems</h5>
                            <p>Fast order processing and payment system</p>
                        </li>
                        <li>
                            <h5>Offline table reservation management</h5>
                            <p>Real-time booking and management</p>
                        </li>
                        <li>
                            <h5>Promotion and event automation management</h5>
                            <p>Event planning and execution automation</p>
                        </li>
                    </ul>
                </li>

                <li class="introduction-sec3__item">
                    <img src="../../assets/resource/icon/introduction-icon06.svg" alt="">
                    <h4>Travel & Hospitality Industry</h4>
                    <ul>
                        <li>
                            <h5>Hotel and travel package reservations</h5>
                            <p>Convenient online reservation system</p>
                        </li>
                        <li>
                            <h5>Membership and loyalty program management</h5>
                            <p>Operating a customer loyalty promotion program</p>
                        </li>
                    </ul>
                </li>
            </ul>
        </section>


    </div>
</template>
<script>
    export default {

    }
</script>
<style>

</style>